import { render, staticRenderFns } from "./Area_miniPicture.vue?vue&type=template&id=b1d7ee52&scoped=true&"
import script from "./Area_miniPicture.vue?vue&type=script&lang=js&"
export * from "./Area_miniPicture.vue?vue&type=script&lang=js&"
import style0 from "./Area_miniPicture.vue?vue&type=style&index=0&id=b1d7ee52&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b1d7ee52",
  null
  
)

export default component.exports